import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { styles } from "../../components/formStyles";

import { useNavigate, useParams } from "react-router-dom";
import { brandViewByAlcoholIdRequest } from "../../../redux/brands/BrandAction";
import { productQuantitySearchViewAllRequest } from "../../../redux/productQuantity/ProductQuantityAction";
import { productViewByBrandIdRequest } from "../../../redux/products/ProductAction";
import { alcoholSearchViewAllRequest } from "../../../redux/typeOfAlcohol/TypeOfAlcoholAction";
import {
  wholesalerProductEditRequest,
  wholesalerProductResetState,
  wholesalerProductViewRequest,
} from "../../../redux/wholesalerProduct/WholesalerProductAction";
import "../../../style/style.css";
import CustomButton from "../../constant/commonButton";
import ReusableFormFields from "../../constant/reusableFormFields";
import { APP_LINKS } from "../../global/wholeSalerMenuItems";
import { mapBackendMessage } from "../../notification/BackendMessage";
import CommonDialog from "../../notification/Dialogbox";

const EditProduct = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    setError,
    watch,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [dialogMessage, setDialogMessage] = useState("");
  const [editTriggered, setEditTriggered] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const [name, setName] = useState("");
  const [filteredProductQuantities, setFilteredProductQuantities] = useState(
    []
  );
  const [brandMessage, setBrandMessage] = useState("");
  const [productMessage, setProductMessage] = useState("");

  const selectedProductId = watch("product_id");
  const wholesalerProductState = useSelector(
    (state) => state.wholesalerProduct?.viewWholesalerProduct?.data || {}
  );
  const wholesalerProductList = wholesalerProductState || [];

  const WholesalerId = useSelector(
    (state) => state?.values?.loginValues?.[0]?.wholesaler_id
  );

  const editWholesalerProductState = useSelector(
    (state) => state.wholesalerProduct?.editWholesalerProduct
  );

  const typeOfAlcoholState = useSelector(
    (state) => state?.TypeAlcohol?.viewAllSearchAlcohols || {}
  );
  const AlcoholList = typeOfAlcoholState?.data?.data || [];

  useEffect(() => {
    dispatch(alcoholSearchViewAllRequest());
  }, [dispatch]);

  const brandViewAllState = useSelector(
    (state) => state?.brand?.viewBrandsByAlcoholId
  );

  const brandList = brandViewAllState?.data?.data || [];
  const selectedAlcoholId = watch("type_of_alcohol_id");

  useEffect(() => {
    if (selectedAlcoholId) {
      dispatch(brandViewByAlcoholIdRequest(selectedAlcoholId));
    }
  }, [selectedAlcoholId, dispatch]);

  const productViewAllState = useSelector(
    (state) => state?.product?.viewProductsByBrandId || {}
  );
  const productList = productViewAllState?.data?.data || [];
  const selectedBrandId = watch("brand_id");

  useEffect(() => {
    if (selectedBrandId) {
      dispatch(productViewByBrandIdRequest(selectedBrandId));
    }
  }, [selectedBrandId, dispatch]);

  const viewAllProductQuantitiesState = useSelector(
    (state) => state?.productQuantity?.viewAllSearchProductQuantities || {}
  );
  const productQuantityList = viewAllProductQuantitiesState?.data?.data || [];

  useEffect(() => {
    dispatch(productQuantitySearchViewAllRequest());
  }, [dispatch]);

  const dynamicAlcoholOptions = AlcoholList?.map((TypeAlcohol) => ({
    value: TypeAlcohol?.id,
    label: TypeAlcohol?.alcohol_type,
  }));

  const dynamicBrandOptions = brandList?.map((brand) => ({
    value: brand?.id,
    label: brand?.brand_name,
  }));
  const dynamicProductOptions = productList?.map((product) => ({
    value: product?.id,
    label: product?.product_name,
  }));

  const defaultCapacity = wholesalerProductList?.ProductQuantity
    ? `${wholesalerProductList.ProductQuantity.type_of_quantity} ${wholesalerProductList.ProductQuantity.measurements}`
    : "Quantity for the selected sub brand does not exist";

  const filterProductQuantities = () => {
    if (!selectedProductId || !WholesalerId) return;

    const filteredOptions = productQuantityList?.filter(
      (item) =>
        item?.product_id === selectedProductId &&
        item?.wholesaler_id === WholesalerId &&
        item?.status === 1
    );

    if (filteredOptions?.length === 0) {
      setFilteredProductQuantities([
        {
          value: "",
          label: (
            <span style={{...styles.capacityWarning}}>
              ⚠ Quantity for the selected sub brand does not exist
            </span>
          ),
          isDisabled: true,
        },
      ]);
    } else {
      setFilteredProductQuantities(
        filteredOptions?.map((item) => ({
          value: item?.id,
          label: `${item?.type_of_quantity} ${item?.measurements || ""}`,
        }))
      );
    }
  };

  const handleCategoryChange = (event) => {
    const selectedProductId = event.target.value;
    setName(selectedProductId);
    setValue("product_id", selectedProductId);
    filterProductQuantities();
    setValue("type_of_quantity_id", "");
  };
  useEffect(() => {}, [selectedProductId]);
  useEffect(() => {
    filterProductQuantities();
  }, [selectedProductId, WholesalerId]);

  const handleAlcoholChange = (event) => {
    const selectedAlcoholId = event.target.value;
    setValue("type_of_alcohol_id", selectedAlcoholId);

    dispatch(brandViewByAlcoholIdRequest(selectedAlcoholId));

    setValue("brand_id", "");
    setValue("product_id", "");
    setValue("type_of_quantity_id", "");

    setBrandMessage("");
    setProductMessage("");
  };

  const handleBrandChange = (event) => {
    const selectedBrandId = event.target.value;
    setValue("brand_id", selectedBrandId);

    dispatch(productViewByBrandIdRequest(selectedBrandId));

    setValue("product_id", "");
    setValue("type_of_quantity_id", "");

    setProductMessage("");
  };

  const filterBrands = () => {
    if (!selectedAlcoholId) return;

    if (dynamicBrandOptions.length === 0) {
      setBrandMessage("⚠ No brands available for the selected alcohol type.");
    } else {
      setBrandMessage("");
    }
  };

  const filterProducts = () => {
    if (!selectedBrandId) return;

    if (dynamicProductOptions.length === 0) {
      setProductMessage("⚠ No sub brand available for the selected brand.");
    } else {
      setProductMessage("");
    }
  };

  useEffect(() => {
    filterBrands();
    filterProducts();
  }, [dynamicBrandOptions, dynamicProductOptions]);

  const inputFields = [
    {
      name: "type_of_alcohol_id",
      label: "Type Of Alochol",
      type: "searchable-select",
      defaultValue: AlcoholList[0]?.id,
      options: dynamicAlcoholOptions,
      onChange: handleAlcoholChange,
      size: "selectMedium",
    },
    {
      name: "brand_id",
      label: "Brand Name",
      type: "searchable-select",
      defaultValue: brandList[0]?.id,
      options: [
        ...dynamicBrandOptions,
        {
          value: "",
          label: brandMessage ? (
            <span style={styles.capacityWarning}>{brandMessage}</span>
          ) : null,
          isDisabled: true,
        },
      ],
      size: "selectMedium",
      onChange: handleBrandChange,
    },
    {
      name: "product_id",
      label: "Sub Brand Name",
      type: "searchable-select",
      defaultValue: productList[0]?.id,
      options: [
        ...dynamicProductOptions,
        {
          value: "",
          label: productMessage ? (
            <span style={styles.capacityWarning}>{productMessage}</span>
          ) : null,
          isDisabled: true,
        },
      ],
      size: "selectMedium",
      onChange: handleCategoryChange,
    },
    {
      name: "type_of_quantity_id",
      label: "Quantity",
      type: "searchable-select",
      defaultValue: defaultCapacity,
      options: filteredProductQuantities,
      size: "selectMedium",
    },
    {
      name: "alcohol_percentage",
      label: "Alochol Percentage",
    },
    { name: "price", label: "Price" },
    {
      name: "quantity",
      label: "Stock",
    },
    {
      name: "status",
      type: "select",
      label: "Status",
      options: [
        { value: "1", label: "Active" },
        { value: "2", label: "InActive" },
      ],
      defaultValue: wholesalerProductList?.status,
    },
  ];

  const handleCancel = () => {
    navigate(APP_LINKS.PRODUCTLIST);
  };
  useEffect(() => {
    if (id) {
      dispatch(wholesalerProductViewRequest(id));
    }
  }, [id, dispatch]);
  useEffect(() => {
    if (wholesalerProductList) {
      setValue("brand_id", wholesalerProductList?.brand_id);
      setValue("product_id", wholesalerProductList?.product_id);
      setValue("type_of_alcohol_id", wholesalerProductList?.type_of_alcohol_id);
      setValue(
        "type_of_quantity_id",
        wholesalerProductList?.type_of_quantity_id
      );
      setValue("alcohol_percentage", wholesalerProductList?.alcohol_percentage);
      setValue("price", wholesalerProductList?.price);
      setValue("quantity", wholesalerProductList?.quantity);
      setValue("status", wholesalerProductList?.status?.toString());
    }
  }, [wholesalerProductList, setValue]);

  const onSubmit = (data) => {
    const formData = {
      ...data,
      wholesaler_id: WholesalerId,
    };
    const editRequestData = {
      ...formData,
      id,
    };
    setEditTriggered(true);
    dispatch(wholesalerProductEditRequest(id, editRequestData));
  };

  const handleEditWholesalerProductResponse = () => {
    if (editWholesalerProductState?.success) {
      setDialogMessage("Product Updated Successfully!");
      setIsSuccess(true);
      setDialogOpen(true);
      setEditTriggered(false);
      dispatch(wholesalerProductResetState());
      // dispatch(wholesalerProductViewRequest(id));
      navigate(APP_LINKS.PRODUCTLIST);
    } else if (editWholesalerProductState?.error) {
      const errorMessage = editWholesalerProductState?.errormessage;
      const errorFields = editWholesalerProductState?.errorFields || {};
      if (Object.keys(errorFields).length > 0) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
      } else if (typeof errorMessage === "string") {
        setError("product_id", {
          type: "manual",
          message: errorMessage,
        });
      } else {
        const customMessage = mapBackendMessage(
          editWholesalerProductState?.errormessage ||
            "An error occurred while updating details."
        );
        setDialogMessage(customMessage);
        setIsSuccess(false);
        setDialogOpen(true);
      }
      dispatch(wholesalerProductViewRequest(id));
    }
  };
  useEffect(() => {
    if (editTriggered) {
      handleEditWholesalerProductResponse();
    }
  }, [editTriggered, editWholesalerProductState]);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1> Update Product Details </h1>
              </Typography>
            </Box>
            {/* Form section */}
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
            />
            {/* Submit Button */}
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Submit"
                    size="medium"
                    type="submit"
                    buttonStyle="StyledButton"
                    disabled={
                      editWholesalerProductState?.editWholesalerProduct
                        ?.inProgress
                    }
                    loading={
                      editWholesalerProductState?.editWholesalerProduct
                        ?.inProgress
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomButton
                    text="Cancel"
                    variant="contained"
                    size="medium"
                    fullWidth
                    buttonStyle="style1"
                    onClick={handleCancel}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>
      {/* Dialog */}
      <CommonDialog
        open={dialogOpen}
        isSuccess={isSuccess}
        onClose={handleDialogClose}
        redirectPath={APP_LINKS.ADDPRODUCT}
        messageSuccess={dialogMessage}
        messageError={dialogMessage}
      />
    </Container>
  );
};
export default EditProduct;
